import Vue from 'vue';
import Router from 'vue-router';
import ReportLayout from '../views/Report/ReportLayout.vue';
import Report from '../views/Report/ReportPage.vue';
import ReportDash from '../views/Report/ReportDash.vue';
import ReportEmpty from '../views/Report/ReportEmpty.vue';
import Login from '../views/Auth/Login.vue';
import Register from '../views/Auth/Register.vue';
import SignUpConfirm from '../views/Auth/SignUpConfirm.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
import { AmplifyEventBus } from 'aws-amplify-vue'
import { getUser } from '../utils/auth.js'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/starter',
      component: ReportLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'starter',
          name: 'starter',
          components: { default: ReportEmpty },
          meta: { requiresAuth: true }
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          components: { default: ReportDash },
          meta: { requiresAuth: true }
        },
        {
            path: 'report/:id',
            name: 'report',
            components: { default: Report },
            meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/',
      component: AuthLayout,
      name: 'Authentication',
      children: [
        {
          path: '/signIn',
          name: 'signIn',
          component: Login
        },
        {
          path: '/signUpConfirm',
          name: 'signUpConfirm',
          component: SignUpConfirm
        },
        {
          path: '/signUp',
          name: 'signUp',
          component: Register
        }
      ]
    }
  ],
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});
AmplifyEventBus.$on('authState', async (state) => {
  const pushPathes = {
    signedOut: () => {
      router.push({ path: '/signIn' })
    },
    signUp: () => {
      router.push({ path: '/signUp' })
    },
    confirmSignUp: () => {
      router.push({ path: '/signUpConfirm' })
    },
    signIn: () => {
      router.push({ path: '/signIn' })
    },
    signedIn: () => {
      router.push({ path: '/' })
    }
  }
  if (typeof pushPathes[state] === 'function') {
    pushPathes[state]()
  }
})

router.beforeResolve(async (to, from, next) => {
  const user = await getUser()
  if (!user) {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      return next({
        path: '/signIn'
      })
    }
  } else {
    if (to.matched.some((record) => typeof (record.meta.requiresAuth) === 'boolean' && !record.meta.requiresAuth)) {
      return next({
        path: '/'
      })
    }
  }
  return next()
})

export default router